<template lang="pug">
.page
	.page__content
		SectionLayout(color="gray" title="Статистика" align="top")

			form.filters(@submit.prevent="showStat()")
				.filters__dropdowns
					select.select(name="tournament_id"
						v-model="filters.tournament" @change="filterTeams(filters.tournament)" :disabled="!hasTournaments" :class="{'disabled':!hasTournaments}")
						option(v-if="!hasTournaments" :value="undefined" disabled) Турниры
						option(v-for="tournament in tournaments" :key="tournament.data.id" :value="tournament.data.id") {{ tournament.data.name }}

					select.select(name="team_id"
						v-model="filters.team" :disabled="!hasTeams" :class="{'disabled':!hasTeams}")
						option(:value="undefined") Все команды
						option(v-for="team in teams" :key="team.data.id" :value="team.data.id") {{ team.data.name }}

					select.select(name="order"
						v-model="filters.order")
						option(:value="undefined") Действия
						option(value="block") Блоки
						option(value="attack") Атаки
						option(value="serve") Подачи
						option(value="fail") Ошибки

					select.select(name="order"
						v-model="filters.orderDirection")
						option(value="asc") По возрастанию
						option(value="desc") По убыванию

				button.button.play.filters__button
					.fas.fa-search
					span.button__text Показать

			.stat-view
				.stat-view__header
					.stat
						.stat__item.stat__name
							i.fas.fa-user
							span.stat__item-heading Имя
						.stat__item.stat__block(:class="{'active':currentOrder=='block'}")
							i.fas.fa-shield-alt
							span.stat__item-heading Блоки
						.stat__item.stat__attack(:class="{'active':currentOrder=='attack'}")
							i.fas.fa-exclamation
							span.stat__item-heading Атаки
						.stat__item.stat__serve(:class="{'active':currentOrder=='serve'}")
							i.fas.fa-volleyball-ball
							span.stat__item-heading Подачи
						.stat__item.stat__fail(:class="{'active':currentOrder=='fail'}")
							i.fas.fa-ban
							span.stat__item-heading Ошибки
				.stat-view__item(v-if="hasStats && !loading" v-for="(stat, index) in statistics" :key="index")
					.stat
						.stat__item.stat__name {{ stat.user_name }}
						.stat__item.stat__block {{ stat.block }}
						.stat__item.stat__attack {{ stat.attack }}
						.stat__item.stat__serve {{ stat.serve }}
						.stat__item.stat__fail {{ stat.fail }}
				.stat-view__item(v-if="loading")
					.stat-message
						.loading.fas.fa-spinner.fa-spin
				.stat-view__item(v-if="!hasStats && !loading")
					.stat-message Статистика отсутствует
			
			.pagination(v-if="paged")
				span.pagination__title Страница:
				button.pagination__item(v-for="number in pages" :key="number" @click="showStat(number)" :class="{'active':filters.page==number}") {{ number }}


</template>

<script>
import Api from '@/api/Requests'
import SectionLayout from '@/components/SectionLayout'

export default {
	name: 'Statistics',
	components: {
		SectionLayout
	},
	data() {
		return {
			statistics: [],
			tournaments: [],
			teams: [],
			filters:{
				tournament: undefined,
				team: undefined,
				order: undefined,
				orderDirection: 'asc',
				page: 1,
				},
			currentOrder: undefined,
			loading: false,
			loadingTeams: false,
			pages: 1
		}
	},
	computed: {
		paged(){
			return this.pages > 1;
		},
		hasTournaments(){
			return this.tournaments.length > 0;
		},
		hasStats(){
			return this.statistics.length > 0;
		},
		hasTeams(){
			return this.teams.length > 0 && !this.loadingTeams ;
		},
	},
	methods: {
		showStat(number = 1){
			this.$set(this.filters, 'page', number);
			this.currentOrder = this.filters.order;

			this.loading = true;

			Api.getStat(this.filters).then( data => {
				this.statistics = data.data;
				this.pages = data.last_page;
				this.loading = false;
			});
		},

		filterTeams(tournamentId){
			this.loadingTeams = true;
			this.$set(this.filters, 'team', undefined);
			

			if (tournamentId !== undefined) {
				Api.getTournamentTeams(tournamentId)
					.then( teams =>{
						this.teams = teams;
						this.loadingTeams = false;
					})
			} else {
				Api.getTeams()
					.then( teams =>{
						this.teams = teams;
						this.loadingTeams = false;
					})
			}
		}
	},
	created(){
		this.loading = true;
		this.loadingTeams = true;

		Api.getTournaments()
			.then(tournaments => {
				this.tournaments = tournaments;
				
				this.$set(this.filters, 'tournament', tournaments[0].data.id);

				Promise.all( [Api.getStat(this.filters), Api.getTournamentTeams(this.filters.tournament)] )
					.then( data => {
						// Has stats
						if ( data[0] ) {
							this.statistics = data[0].data;
							this.pages = data[0].last_page;
						}
						// Has teams
						if ( data[1] ) { this.teams = data[1]; }

						this.loadingTeams = false;
						this.loading = false;
					})
			})


	}
}
</script>

<style lang="sass" scoped>
@import "@/assets/style/pages/stats.sass"
</style>


// WEBPACK FOOTER //
// src/Views/Statistics.vue